import React from "react";
import { useParams } from 'react-router';
import { useDispatch } from "react-redux";

import { Button } from "rhombus-react";

import EmptySection from "widgets/EmptySection";
import { loadConcept } from "reducers/ConceptDetails";

export default function ConceptLoadError(props){
	const dispatch = useDispatch();
	const { libraryId, conceptId } = useParams();

	const buttons = <Button onClick={() => { dispatch(loadConcept(libraryId, conceptId)); }}>Try Again</Button>;

	const sectionProps = {
		className: "not-found",
		src: "/images/404.svg",
		header: "Oops!",
		message: "There was a problem loading the concept",
		buttons,
	};

	return <EmptySection {...sectionProps} />;
}

ConceptLoadError.displayName = "ConceptLoadError";
